export default __webpack_public_path__ + "static/media/notaries.596aed60.svg";